import React, { FC, memo, useMemo } from 'react';

import { sortBy } from 'lodash';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FlexColumn,
} from '@portal/common/components';
import { REI_ID_KEY } from '@portal/common/models/data-key';
import theme from '@portal/common/theme';
import { mapGranularityKeyToLocalePrefix } from '@portal/common/utility/filters-helpers';

import _ from '../../locale/_';
import { accordionDetailsStyle } from './DataLicenseView';
import FilterRow from './FilterRow';
import SummaryRow from './SummaryRow';

type Props = {
    data: {
        name: string;
        prefix: string | undefined;
        totalItems: number[];
        items: number[];
        percentage: number;
    };
    dataCollectionId: string;
};

export const DataTypeRow: FC<Props> = memo(
    ({
        data: [typeKey, { total_percentage, filter_percentage, total_granularity, granularity }],
        dataCollectionId,
    }) => {
        const name = _.get('data_license_type_' + typeKey);
        const percentage = total_percentage;
        const rows = useMemo(() => {
            const data = Object.entries(total_granularity).map(([filterKey, filterValues]) => {
                const filterKeyWithRei = filterKey === REI_ID_KEY ? typeKey : filterKey;
                const name = _.get('data_license_' + filterKeyWithRei);
                const prefix = mapGranularityKeyToLocalePrefix(filterKey);
                const totalItems = filterValues!;
                const items = granularity[filterKey];
                const percentage = filter_percentage[filterKey];

                return { name, prefix, totalItems, items, percentage };
            });
            return sortBy(data, ['name']);
        }, [total_granularity, typeKey, granularity, filter_percentage]);

        const id = `${dataCollectionId}-${name}`;

        return (
            <div key={name}>
                <Accordion backgroundColor={theme.color.surface} id={id}>
                    <AccordionSummary arrowSize="medium">
                        <SummaryRow name={name} percentage={percentage} dataName={name} />
                    </AccordionSummary>
                    <AccordionDetails style={accordionDetailsStyle}>
                        <FlexColumn grow={1}>
                            {rows.map((item) => (
                                <FilterRow
                                    data={item}
                                    id={`${id}-${item.name}`}
                                    key={`${id}-${item.name}`}
                                />
                            ))}
                        </FlexColumn>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }
);

export default DataTypeRow;
